import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { translate } from '../../../../I18n/i18n';

import './MessagingView.scss';
import { EmptyContentText } from '../../common/components/EmptyContentText/EmptyContentText';
import { Button, Dot, withAppStyle, WithAppStyleProps, GetLocale } from '@cuatroochenta/co-admin-react-library';
import CreateConversationModal from './components/CreateConversationModal';
import { ShareResidentOption } from '../../../model/domain/share-option';
import { Conversation, MessagingGroup } from '../../../model/domain/messaging';
import { CreateConversationRequest } from '../../../model/data/messaging';

interface MessagingViewProps {
    showCreateButton: boolean;
    showCreateModal: boolean;
    conversations: Conversation[];
    messagingGroups: MessagingGroup[];
    selectedConversation: Conversation | null;
    residentShareOptions: ShareResidentOption[] | null
    loadingShareOptions: boolean;
    loadingCreateConversation: boolean;
    errorCreateConversation: Error | null;
    onCreateStart: () => void;
    onCreateCancel: () => void;
    onCreateFinish: (formData: CreateConversationRequest) => void;
    onConversationClick: (conversation: Conversation) => void;
}

interface MessagingViewState {
    conversations: Conversation[];
}

type Props = MessagingViewProps & WithTranslation & WithAppStyleProps

class MessagingView extends React.Component<Props, MessagingViewState> {

    constructor(props: Props) {
        super(props);
        this.state = {
            conversations: []
        };
    }

    componentDidMount(): void {
        this.setState({ conversations: this.props.conversations })
    }

    componentDidUpdate(prevProps: MessagingViewProps) {
        if (prevProps.conversations !== this.props.conversations) {
            this.setState({ conversations: this.props.conversations });
        }
    
        if (prevProps.selectedConversation !== this.props.selectedConversation &&
            this.props.selectedConversation) {
            const updatedConversation = this.props.conversations.find(
                (c) => c.id === this.props.selectedConversation?.id
            );
            console.log('Conversación actualizada:', updatedConversation);
        }
    }

    private handleConversationClick(conversation: Conversation) {
        this.props.onConversationClick(conversation);
    }

    private formatDate(dateString: string): string {
        const date = new Date(dateString);
        const datePart = date.toLocaleDateString(GetLocale());
        const timePart = date.toLocaleTimeString(GetLocale(), { hour: '2-digit', minute: '2-digit' });
        return `${datePart} ${timePart}`;
    }

    private renderConversationCard(conversation: Conversation) {
        return (
            <div className='col-md-12'
                onClick={() => this.handleConversationClick(conversation)}
                style={{ cursor: 'pointer' }}
                key={conversation.id}>
                <div className="card shadow p-3 hover-card">
                    <div className="card-body-conversations">
                        <div className="conversation-item recipient">
                        <label>{conversation.sender_name ? conversation.sender_name : conversation.sender_email}</label>
                        </div>
                        <div className="conversation-item subject">
                            <label>{conversation.subject}</label>
                        </div>
                        <div className="conversation-item last-message">
                            <label>{conversation.last_message_content}</label>
                        </div>
                        <div className="conversation-item date">
                            <label>{this.formatDate(conversation.last_message_date)}</label>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderConversationTable() {
        const { conversations } = this.state;
        const { t } = this.props;

        return (
            <table className="messaging-table">
                <thead style={{color: this.props.appStyles.primaryColor}}>
                    <tr>
                        <th>{translate(t, 'messages.TR_SENDER_TABLE_LABEL')}</th>
                        <th>{translate(t, 'messages.TR_SUBJECT_LABEL')}</th>
                        <th>{translate(t, 'messages.TR_MESSAGE_LABEL')}</th>
                        <th>{translate(t, 'messages.TR_DATE_LABEL')}</th>
                    </tr>
                </thead>
                <tbody>
                    {conversations.map((conversation) => (
                        <tr
                            key={conversation.id}
                            onClick={() => this.handleConversationClick(conversation)}
                            className="table-row"
                        >
                            <td>
                                {conversation.unreadMessageCount > 0 ? (
                                    <Dot trailingSpace={10} />
                                ) : null}
                                {conversation.sender_name ? conversation.sender_name : conversation.sender_email}
                            </td>
                            <td>{conversation.subject}</td>
                            <td>{conversation.last_message_content}</td>
                            <td>{this.formatDate(conversation.last_message_date)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    }

    public render() {
        const { conversations } = this.state;
        const {
            t,
            showCreateButton,
            showCreateModal,
            messagingGroups,
            residentShareOptions,
            loadingShareOptions,
            loadingCreateConversation,
            errorCreateConversation,
            onCreateStart,
            onCreateCancel,
            onCreateFinish,
        } = this.props;

        return (
            <div>
                <div className="card-title-messaging">{translate(t, 'messages.TR_MESSAGING_LABEL')}</div>
                {showCreateButton ? (
                    <Button
                        onClick={onCreateStart}
                        content={translate(t, 'messages.TR_CREATE_LABEL')}
                    />
                ) : null}
                {conversations.length === 0 ? (
                    <EmptyContentText
                        message={translate(t, 'messages.TR_NO_MESSAGES_LABEL')}
                    />
                ) : (
                    this.renderConversationTable()
                )}

                <CreateConversationModal
                    show={showCreateModal}
                    messagingGroups={messagingGroups}
                    residentShareOptions={residentShareOptions}
                    loadingShareOptions={loadingShareOptions}
                    loadingCreateConversation={loadingCreateConversation}
                    error={errorCreateConversation}
                    onClose={onCreateCancel}
                    onConfirm={onCreateFinish}
                />
            </div>
        );
    }
}

export default withAppStyle(withTranslation()(MessagingView));